<lib-page-header [title]="userEdit.displayName"
                 screenName="User"
                 backTo="/administration/users"
                 backLabel="Back to users">
    <div icon class="user-avatar-disc" *ngIf="userEdit.isUpdateMode(); else newUserIcon">
        {{ userEdit.getUserInitials() }}
    </div>
    <ng-template #newUserIcon><mat-icon>person_add</mat-icon></ng-template>

    <ng-container subtitle *ngIf="userEdit.isUpdateMode()">
        <mat-icon class="meta-icon">badge</mat-icon> {{ userEdit.user.username }}
        <span class="meta-sep">·</span>
        <mat-icon class="meta-icon">email</mat-icon> {{ userEdit.user.email || '—' }}
    </ng-container>

    <ng-container stats *ngIf="userEdit.isUpdateMode() && userEdit.grantedRolesCount() > 0">
        <div class="page-header-stat">
            <mat-icon>shield</mat-icon>
            <span class="stat-value">{{ userEdit.grantedRolesCount() }}</span>
            <span class="stat-label">Roles</span>
        </div>
    </ng-container>

    <ng-container actions>
        <button mat-flat-button color="primary"
                *ngIf="!userEdit.isDeletedUser()
                       && ((userEdit.capabilities.hasCapability('user:create') && userEdit.isCreateMode())
                           || (userEdit.capabilities.hasCapability('user:update') && userEdit.isUpdateMode()))"
                [disabled]="!userEdit.canSave()" (click)="userEdit.onSave()">
            <mat-icon>save</mat-icon>
            Save
        </button>
        <button mat-flat-button color="primary"
                *ngIf="userEdit.isDeletedUser() && userEdit.capabilities.hasCapability('user:delete')"
                (click)="userEdit.onRestore()">
            <mat-icon>restore</mat-icon>
            Restore User
        </button>
    </ng-container>
</lib-page-header>

<lib-user-edit #userEdit
    (buildCreatePayload)="buildTaskSenseCreatePayload($event)"
    (buildUpdatePayload)="buildTaskSenseUpdatePayload($event)"
    (saved)="onUserSaved($event)">
</lib-user-edit>
